export default __webpack_public_path__ + "images/4e83abaffecbe45a53639639297f0cb6-painting.webp";